import NotificationSimple from './NotificationSimple.vue'
import NotificationRecord from './NotificationRecord.vue'

export default {
  NotificationSimple,
  NotificationRecord,
}
